module.exports = __webpack_public_path__ + "static/5-e9322b234c38506cd5dea1ac5b70c496.jpg";